import { Routes } from "@angular/router";

import { DashBoardResolverService } from "../services/resolvers/dashboard-resolver.service";
import { ProfileDetailsResolverService } from "../services/profile-details-resolver.service";

export const routes: Routes = [
	{
		path: "",
		resolve: { profileDetails: ProfileDetailsResolverService },
		children: [
			{
				path: "",
				loadComponent: () => import('./kudoshub-home.component').then(m => m.KudoshubHomeComponent),
				data: {
					title: "KudosHub Technologies | Home",
					description:
						"KudosHub, a trusted IT leader that works on solving the digital challenges you may face and help your business flourish.",
					keywords:
						"email validation service, livechat & customer support, email marketing, web design & development, mobile applications",
					ogTitle: "KudosHub | home",
					ogDesc:
						"KudosHub, a trusted IT leader that works on solving the digital challenges you may face and help your business flourish.",
					ogImage: "https://kudoshub.com/theme/images/og-images/home01.webp",
					ogUrl: "https://kudoshub.com",
					twitterTitle: 'KudosHub Technologies | Home',
					twitterDesc: 'KudosHub, a trusted IT leader that works on solving the digital challenges you may face and help your business flourish.',
					twitterImage: 'https://kudoshub.com/theme/images/og-images/home01.webp',
				},
			},
			{
				path: "verify-account",
				loadComponent: () => import('./kudoshub-home.component').then(m => m.KudoshubHomeComponent),
				data: {
					title: "KudosHub | Verify Account",
				},
			},
			{
				path: "verify-subscriber",
				loadComponent: () => import('./kudoshub-home.component').then(m => m.KudoshubHomeComponent),
				data: {
					title: "KudosHub | Verify Subscriber",
				},
			},
			{
				path: "verify-admin-invoice",
				loadComponent: () => import('./kudoshub-home.component').then(m => m.KudoshubHomeComponent),
			},
			{
				path: "reset-password",
				loadChildren:
					() => import('../reset-password/reset-password.routes').then(m => m.routes),
			},

			{
				path: "forgot-password",
				loadChildren:
					() => import('../forgot-password/forgot-password.routes').then(m => m.routes),
			},

			{
				path: "unsubscribe",
				loadChildren: () => import('../unsubscribe/unsubscribe.routes').then(m => m.routes),
			},

			{
				path: "dashboard",
				//canActivate: [serviceGuard],
				resolve: { profileDetails: DashBoardResolverService },
				loadChildren: () => import('../dashboard/dashboard.routes').then(m => m.routes),
			},

			{
				path: "verify-users-delete",
				loadComponent: () => import('./kudoshub-home.component').then(m => m.KudoshubHomeComponent),
			},

			{
				path: "services",
				loadChildren: () => import('../all-services/all-services.routes').then(m => m.routes),
			},
		],
	},
];